// DB-Frontend/src/pages/KeyPage.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../Assets/images/logo.png";
import Header from "../Header/header.js";
import Footer from "../Footer/footer.js";
import { verifyKey } from "./_request.js";

function KeyPage() {
  const [userKey, setKey] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleKeySubmit = async (e) => {
    e.preventDefault();
    try {
      // Verify key with backend
      const response = await verifyKey(userKey);
      if (response) {
        const approved = true;
        navigate("/database-form", { state: { approved } });
      }
    } catch (err) {
      setError("Invalid key. Please try again.");
    }
  };

  return (
    <>
      <Header />
      <div className="flex flex-col items-center justify-center py-28 lg:py-40 p-4">
        <div className="text-center mb-8">
          <img src={logo} alt="AMN Logo" className="w-20 h-20 mx-auto" />
          <h1 className="text-4xl font-bold mt-4">AMN - Database</h1>
        </div>
        <form onSubmit={handleKeySubmit} className="flex flex-col items-center">
          <input
            type="text"
            placeholder="Enter Key"
            value={userKey}
            onChange={(e) => setKey(e.target.value)}
            className="border border-gray-400 p-4 rounded-lg text-center mb-4 w-64"
            required
          />
          <button
            type="submit"
            className="bg-primary hover:bg-blue-400 text-white py-2 px-8 rounded"
          >
            Submit
          </button>
          {error && <p className="text-red-500 mt-2">{error}</p>}
        </form>
      </div>
      <Footer />
    </>
  );
}

export default KeyPage;
